"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useMount = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = require("react");

/**
 * Execute a callback when a component is mounted. Exactly like the component
 * class `public componentDidMount()` method, or the `useEffect(callback, [])`
 * hook with an empty dependency array.
 *
 * Also returns a boolean which is initially false, but becomes true after the
 * mount callback has run.
 */
var useMount = function useMount(callback) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  (0, _react.useEffect)(function () {
    callback();
    setReady(true);
  }, []);
  return ready;
};

exports.useMount = useMount;